import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [sp] = useSearchParams();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      const next = sp.get("next");
      navigate(next || (u.role === "admin" ? "/admin" : "/"));
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="overline">Welcome back</div>
      <h1 className="font-display text-4xl mt-2">Sign in to Eko</h1>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="input-eko" />
        <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="input-eko" />
        <button data-testid="login-submit" disabled={loading} className="btn-primary w-full justify-center">{loading ? "Signing in…" : "Sign in"}</button>
      </form>
      <p className="mt-6 text-sm text-[#6C665F]">New here? <Link to="/register" className="link-underline text-[#8C3A3A]">Create an account</Link></p>
    </div>
  );
}
